import cx from 'classnames';

import {Icon, IconName} from '../Icon';

type Props = {
    icon?: IconName;
    className?: string;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const CardRow: React.FC<Props> = ({children, className, icon}: Props) => (
    <div className={cx('tw-mt-2 tw-flex tw-items-center', className)}>
        {icon && <Icon name={icon} className='tw-ml-1.5' />}
        <div className='tw-flex-1 tw-break-words tw-overflow-hidden tw-ml-4'>
            {children}
        </div>
    </div>
);
